import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useCallback, useState } from "react";
import UnForm from "../../../../../../Components/Form";
import { useAtendimentoPage } from "../../../../../../Context/AtendimentoPage";
import { ListarDocumentoTemplateController } from "../../../../../../Controllers/Geral/Documentos/DocumentosController";
import { ListarCategoriaAtendimentoAoClienteController } from "../../../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import useAsyncCallback from "../../../../../../hooks/useAsyncCallback";
import { ListarGruposController } from "../../../../../../Controllers/Geral/Grupos/GruposController";
import { ListarEquipesController } from "../../../../../../Controllers/HelpDesk/Equipes/EquipesControllers";
import {
    CadastrarAcaoEtapaController,
    ListarTiposAcoesReguaController,
} from "../../../../../../Controllers/Automacao/Regua/GestaoDeRegua/GestaoDeReguaControllers";
import { ICadastrarAcaoEtapaBody } from "../../../../../../Interfaces/Automacao/Regua/GestaoDeRegua/GestaoDeReguaInterfaces";

interface IModalCadastrarAcaoEtapaProps {
    setShow: (show: boolean) => void;
    updateList: () => void;
    idEtapaRegua: number;
}

export default function ModalCadastrarAcaoEtapa(
    props: IModalCadastrarAcaoEtapaProps
) {
    const { execute: cadastrarAcaoEtapa, loading: cadastrarAcaoEtapaLoading } =
        useAsyncCallback(CadastrarAcaoEtapaController);
    const [idAcao, setIdAcao] = useState<number>(0);
    const [idDocumento, setIdDocumento] = useState<number>(0);
    const onSubmit = (formData: ICadastrarAcaoEtapaBody) => {
        getDocumentoTemplate(formData);
        cadastrarAcaoEtapa({
            ...formData,
            ID_CASO_COBRANCA_REGUA_ETAPA: props.idEtapaRegua,
        }).then((res) => {
            props.setShow(false);
            // reset();
            props.updateList();
        });
    };

    const { idModulo } = useAtendimentoPage();

    const listarDocumentosTemplateSimples = useCallback(() => {
        return ListarDocumentoTemplateController({ idTipoCaso: idModulo, FL_NAO_CARREGA_TEMPLATE: true });
    }, [idModulo]);

    function getDocumentoTemplate(formData: ICadastrarAcaoEtapaBody) {
        if (idAcao === 1 || idAcao === 6) {
            formData.ID_TEMPLATE_SMS = idDocumento;

            formData.ID_TEMPLATE_EMAIL = 0;
            formData.ID_TEMPLATE_DISTRIBUICAO = 0;
        }
        if (idAcao === 2 || idAcao === 5 || idAcao === 7 || idAcao === 8) {
            formData.ID_TEMPLATE_EMAIL = idDocumento;

            formData.ID_TEMPLATE_SMS = 0;
            formData.ID_TEMPLATE_DISTRIBUICAO = 0;
        }
        if (idAcao === 3) {
            formData.ID_TEMPLATE_DISTRIBUICAO = idDocumento;

            formData.ID_TEMPLATE_SMS = 0;
            formData.ID_TEMPLATE_EMAIL = 0;
        }
        if (idAcao === 0) {
            formData.ID_TEMPLATE_SMS = 0;
            formData.ID_TEMPLATE_EMAIL = 0;
            formData.ID_TEMPLATE_DISTRIBUICAO = 0;
        }
    }

    return (
        <>
            <div className="text-center mb-10 mb-lg-20">
                <h2 className="font-weight-bold">Cadastro de Ação de Etapa</h2>
            </div>
            <UnForm className="form" handleSubmit={onSubmit}>
                {({ getValues }) => (
                    <>
                        <div className="form-group border-bottom py-3 b-5">
                            <UnForm.Input
                                type="text"
                                placeholder="Nome da Ação"
                                name="DS_NOME_ACAO"
                                registerOptions={{
                                    required: "Insira o nome da ação da etapa",
                                }}
                                autoComplete="off"
                            />
                        </div>
                        <div className="form-group border-bottom py-3 b-5">
                            <UnForm.LazySelect
                                label="Template Documento"
                                className={`form-control h-auto border-0 px-0 placeholder-dark-75`}
                                placeholder="Nome da Etapa"
                                name="ID_DOCUMENTO_TEMPLATE"
                                controller={listarDocumentosTemplateSimples}
                                getDS={(dt) => dt.DS_DOCUMENTO}
                                getKeyValue={(dt) => dt.ID_DOCUMENTO_TEMPLATE}
                                onChange={(e) =>
                                    setIdDocumento(Number(e.target.value))
                                }
                                autoComplete="off"
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        <div className="form-group border-bottom py-3 b-5">
                            <UnForm.LazySelect
                                label="Tipo de Ação"
                                placeholder="Nome da Etapa"
                                name="ID_TIPO_ACAO"
                                controller={ListarTiposAcoesReguaController}
                                getDS={(dt) => dt.DS_TIPO_ACAO}
                                getKeyValue={(dt) =>
                                    dt.ID_CASO_COBRANCA_REGUA_TIPO_ACAO
                                }
                                registerOptions={{
                                    required: "Escolha um tipo de ação",
                                }}
                                onChange={(e) =>
                                    setIdAcao(Number(e.target.value))
                                }
                                autoComplete="off"
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        {idAcao === 3 ? (
                            <div className="form-group border-bottom py-3 b-5">
                                <UnForm.LazySelect
                                    label="Grupo"
                                    placeholder="Nome da Etapa"
                                    name="ID_GRUPO_DISTRIBUICAO"
                                    controller={ListarGruposController}
                                    getDS={(dt) => dt.DS_GRUPO}
                                    getKeyValue={(dt) => dt.ID_GRUPO}
                                    registerOptions={{
                                        required: "Escolha um Grupo",
                                    }}
                                    autoComplete="off"
                                >
                                    <option></option>
                                </UnForm.LazySelect>
                            </div>
                        ) : null}
                        <div className="form-group border-bottom py-3 b-5">
                            <UnForm.LazySelect
                                label="Categoria Atendimento"
                                className={`form-control h-auto border-0 px-0 placeholder-dark-75`}
                                placeholder="Nome da Etapa"
                                name="ID_CATEGORIA_ATENDIMENTO"
                                controller={
                                    ListarCategoriaAtendimentoAoClienteController
                                }
                                getDS={(dt) => dt.DS_CATEGORIA_ATENDIMENTO}
                                getKeyValue={(dt) =>
                                    dt.ID_CATEGORIA_ATENDIMENTO
                                }
                                autoComplete="off"
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        <div className="form-group border-bottom py-3 b-5">
                            <UnForm.LazySelect
                                label="Equipe de atendimento"
                                name="ID_EQUIPE_HELPDESK"
                                className={`form-control h-auto border-0 px-0 placeholder-dark-75`}
                                controller={ListarEquipesController}
                                getDS={(u) => u.DS_EQUIPE_HELP_DESK}
                                getKeyValue={(u) => u.ID_EQUIPE_HELP_DESK}
                                registerOptions={{
                                    setValueAs: (v) => {
                                        if (!v) {
                                            return "";
                                        } else {
                                            return v;
                                        }
                                    },
                                }}
                            >
                                <option></option>
                            </UnForm.LazySelect>
                        </div>
                        <div className="d-flex flex-wrap justify-content-center align-items-center">
                            <UnForm.SubmitButton
                                icon={faPaperPlane}
                                color="primary"
                                type="submit"
                                className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                                loading={cadastrarAcaoEtapaLoading}
                                loadingSize="sm"
                            >
                                Cadastrar
                            </UnForm.SubmitButton>
                        </div>
                    </>
                )}
            </UnForm>
        </>
    );
}
